import { DateInput } from '@framework/form/inputs/DateInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { getWidgetDateFormat, type IDateWidget } from './IDateWidget.ts';

type IDateWidgetComponentProps = IWidgetComponentProps<IDateWidget>;

export function DateWidgetComponent(props: IDateWidgetComponentProps) {
  const options = getWidgetProps(props);

  const format = getWidgetDateFormat(props.widget);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <DateInput
        readOnly={props.readonly}
        name={options.name}
        type={format.serializeFormat === 'YYYY-MM-DD' ? 'date' : 'datetime'}
        showTime={format.serializeFormat !== 'YYYY-MM-DD'}
        format={format.datePickerFormat}
        placeholder={options.placeholder ?? format.placeholder}
        value={options.value}
        tabIndex={options.preview ? -1 : undefined}
      />
    </ConfigFormItem>
  );
}
